import { useEffect, useState } from 'react';

const WHATSAPP_LINK = 'https://wa.me/5521974393072?text=Ol%C3%A1!%20Gostaria%20de%20uma%20consulta%20jur%C3%ADdica.';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 150);
    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="inicio"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        {/* Mobile image */}
        <img
          src="https://storage.readdy-site.link/project_files/d8bcc27c-0b18-4a10-81b7-54a88326e269/2c4add6e-234e-4081-9d29-6d827a7edf7c_png-vertical.png?v=31437f27bbd90d502abe4b6ea1fadbfe"
          alt="Escritório Carvalho e França Advogadas"
          className="md:hidden w-full h-full object-cover object-top"
        />
        {/* Desktop image */}
        <img
          src="https://storage.readdy-site.link/project_files/d8bcc27c-0b18-4a10-81b7-54a88326e269/09af5f7c-d6a1-4282-8eaa-913f97e70f85_IMG_9506.jpg?v=708b72bb8032f32e373dea8c160c9b0b"
          alt="Escritório Carvalho e França Advogadas"
          className="hidden md:block w-full h-full object-cover object-center"
        />
        {/* Dark overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-marrom-escuro/90 via-marrom-escuro/75 to-marrom-escuro/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-marrom-escuro/60 via-transparent to-marrom-escuro/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Label */}
          <div
            className={`flex items-center gap-3 mb-8 transition-all duration-700 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <div className="w-10 h-px bg-dourado-principal" />
            <span className="font-sans text-dourado-claro text-xs tracking-widest uppercase">
              Duque de Caxias – Rio de Janeiro
            </span>
          </div>

          {/* H1 */}
          <h1
            className={`font-serif text-white text-5xl lg:text-6xl xl:text-7xl leading-tight font-light mb-6 transition-all duration-700 delay-100 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Advocacia com{' '}
            <em className="text-dourado-principal not-italic font-semibold">
              seriedade
            </em>
            ,{' '}
            <em className="text-dourado-principal not-italic font-semibold">
              estratégia
            </em>{' '}
            e compromisso com seus direitos
          </h1>

          {/* Subtitle */}
          <p
            className={`font-sans text-white/75 text-lg leading-relaxed mb-10 max-w-xl transition-all duration-700 delay-200 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Atuação especializada nas áreas trabalhista, consumidor, família e
            previdenciário — com atendimento humanizado e resultados concretos.
          </p>

          {/* CTAs */}
          <div
            className={`flex flex-col sm:flex-row items-start sm:items-center gap-4 transition-all duration-700 delay-300 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-3 bg-dourado-principal hover:bg-dourado-medio text-marrom-escuro font-sans font-bold text-sm px-8 py-4 rounded-md transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl" />
              </div>
              Fale com uma advogada
            </a>

            <button
              onClick={() => scrollToSection('#areas')}
              className="flex items-center gap-3 border border-white/40 hover:border-dourado-principal text-white hover:text-dourado-principal font-sans text-sm px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Nossas Áreas de Atuação
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line text-base" />
              </div>
            </button>
          </div>

          {/* Stats */}
          <div
            className={`mt-16 flex items-center gap-10 transition-all duration-700 delay-400 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            {[
              { num: '4', label: 'Áreas de Atuação' },
              { num: '100%', label: 'Comprometimento' },
              { num: '24h', label: 'Atendimento via WhatsApp' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="font-serif text-dourado-principal text-3xl font-semibold">{stat.num}</p>
                <p className="font-sans text-white/60 text-xs mt-1 tracking-wide">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-3 sm:bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60">
        <span className="font-sans text-white/50 text-xs tracking-widest uppercase">Rolar</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
